/* !
 * news.js v1.0.0
 * Copyright, Connecty Inc.
 */
((JDI) => {
    const a = 'is-active';
    const v = 'is-visible';

    const newsCurrent = () => {
        if (document.querySelectorAll('.news-tab').length) {
            const links = document.querySelectorAll('.news-tab li a');

          	for (let i = 0; i < links.length; i++) {
            	if (location.pathname === links[i].getAttribute('href')) {
              		links[i].classList.add(a);
            	}
          	}
        }
    };

    const newsTopicsSlide = () => {
        let topicsSlider;
        const topicsContainer = document.querySelector('.topics-container');
        const topicsList = document.querySelector('.topics-list');

        if (!topicsContainer || !topicsList) {
            return;
        }
        const breakpoint = 767;

        function setupSplide() {
            if (window.innerWidth <= breakpoint) {
                if (!topicsContainer.classList.contains('is-slider')) {
                    topicsContainer.classList.add('is-slider');
                    topicsList.classList.add('splide__list');
                    const items = topicsList.querySelectorAll('li');
                    items.forEach(item => {
                        item.classList.add('splide__slide');
                    });

                    const trackDiv = document.createElement('div');
                    trackDiv.className = 'splide__track';
                    topicsContainer.removeChild(topicsList);
                    trackDiv.appendChild(topicsList);
                    topicsContainer.appendChild(trackDiv);

                    topicsSlider = new Splide(topicsContainer, {
                        perPage: 1,
                        gap: '1rem',
                        pagination: true,
                        arrows: true,
                        autoplay: true,
                        interval: 5000,
                        pauseOnHover: true,
                        pauseOnFocus: true,
                        rewind: true,
                        classes: {
                            list: 'splide__list mod-column mod-spacer_40 topics-list',
                        }
                    }).mount();
                }
            } else {
                if (topicsContainer.classList.contains('is-slider')) {
                    if (topicsSlider) {
                        topicsSlider.destroy(true);
                        topicsSlider = null;
                    }

                    topicsContainer.classList.remove('is-slider');
                    const items = topicsList.querySelectorAll('li');
                    items.forEach(item => {
                        item.classList.remove('splide__slide');
                    });

                    const trackDiv = topicsContainer.querySelector('.splide__track');
                    if (trackDiv) {
                        trackDiv.parentNode.appendChild(topicsList);
                        trackDiv.remove();
                    }

                    topicsList.classList.remove('splide__list');
                }
            }
        }

        setupSplide();

        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                setupSplide();
            }, 200);
        });
    };

    const initializeNewsTabs = () => {
        const currentLang = location.pathname.startsWith('/en/') ? 'en' : 'jp';
        const isEnglish = currentLang === 'en';

        const jsonPath = isEnglish ? '/ajax/en/news_all.json' : '/ajax/jp/news_all.json';
        const itemsPerPage = 20;
        const categoryKeyMappings = {
            menu01: [20, 30, 40, 50, 60],
            menu02: [20, 30, 40, 60],
            menu03: [50]
        };
        const newsListContainerSelectors = {
            menu01: '#menu01 .news-article-list',
            menu02: '#menu02 .news-article-list',
            menu03: '#menu03 .news-article-list'
        };
        const paginationContainerSelectors = {
            menu01: '#menu01 .pagination-container',
            menu02: '#menu02 .pagination-container',
            menu03: '#menu03 .pagination-container'
        };
        const yearSelectElement = document.querySelector('.js-news-yearList');
        const latestYearElement = document.querySelector('.js-news-latest-year');
        const earliestYearElement = document.querySelector('.js-news-earliest-year');

        const texts = {
            latest: isEnglish ? 'Latest' : '最新',
            no_articles: isEnglish ? 'No articles found.' : '該当する記事はありません。',
            error_loading: isEnglish ? 'An error occurred while loading news.' : 'ニュースの読み込み中にエラーが発生しました。'
        };

        if (!yearSelectElement || !latestYearElement || !earliestYearElement) {
            console.error('Error: Year select or display elements not found.');
            return;
        }

        let allNewsItems = [];
        let tabFilteredData = {};
        let tabPaginationState = {};

        const formatDate = (dateString) => {
            if (!dateString) return '';
            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) throw new Error('Invalid date format');

                if (isEnglish) {
                    // English format: Month Day, Year (e.g., Apr 9, 2025)
                    return date.toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                    });
                } else {
                    // Japanese format: YYYY/MM/DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}/${month}/${day}`;
                }
            } catch (error) {
                console.error(`Error formatting date: ${dateString}`, error);
                return '';
            }
         };
        const isNew = (dateString) => {
            if (!dateString) return false;
            try {
                const newsDate = new Date(dateString);
                if (isNaN(newsDate.getTime())) return false;
                const oneMonthAgo = new Date();
                oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
                return newsDate > oneMonthAgo;
            } catch (error) {
                console.error(`Error checking if news is new: ${dateString}`, error);
                return false;
            }
         };
        const _url = (format, ...args) => {
            let index = 0;
            return format.replace(/%s/g, () => args[index++] || '');
         };
         const generateUrlAttributes = (item) => {
            const type = item.cf_n_type;
            const key = item._key;
            const attachment = isEnglish ? item.cf_n_attachment_file_en : item.cf_n_attachment_file_jp;
            const url = isEnglish ? item.cf_n_url_en : item.cf_n_url_jp;
            const effectiveUrl = url || (isEnglish ? item.cf_n_url_jp : item.cf_n_url_en) || '';
            const effectiveAttachment = attachment || (isEnglish ? item.cf_n_attachment_file_jp : item.cf_n_attachment_file_en) || '';

            let attributes = { href: '#', target: '_self', style: '', class: '' };
            const basePath = isEnglish ? "/en/news" : "/news"; // ベースパスを定義

            try {
                switch (type) {
                    case 1:
                        attributes.href = _url(`${basePath}/release/detail/%s.html`, key); // ベースパスを使用
                        break;
                    case 2:
                        if (effectiveAttachment) {
                            attributes.href = _url(`${basePath}/news_file/file/%s`, effectiveAttachment); // ベースパスを使用
                            attributes.target = "_blank";
                        } else {
                             attributes.href = "#";
                             attributes.style = "pointer-events:none; cursor:default;";
                        }
                        break;
                    case 3:
                        if (effectiveUrl) {
                            if (/^https?:\/\//.test(effectiveUrl)) {
                                attributes.target = "_blank";
                                attributes.href = _url("%s", effectiveUrl);
                            } else if (/^\//.test(effectiveUrl)) {
                                attributes.target = "_self";
                                // 英語の場合、先頭に /en を追加するかどうかを検討 (現状はそのまま)
                                // attributes.href = _url(isEnglish ? `/en${effectiveUrl}` : effectiveUrl);
                                attributes.href = _url("%s", effectiveUrl);
                            } else if (/^[a-zA-Z0-9_-]+$/.test(effectiveUrl)) {
                                attributes.target = "_blank";
                                attributes.href = _url("https://www.youtube.com/watch?v=%s", effectiveUrl);
                            } else {
                                attributes.target = "_blank";
                                attributes.href = _url("%s", effectiveUrl);
                            }
                        } else {
                             attributes.href = "#";
                             attributes.style = "pointer-events:none; cursor:default;";
                        }
                        break;
                    case 5:
                        attributes.style = "pointer-events:none; cursor:default; text-decoration:none;";
                        attributes.class = "rt_cf_nolink";
                        attributes.href = "#";
                        break;
                    default:
                        attributes.href = "#";
                        break;
                }
            } catch (error) {
                console.error(`Error generating URL for item key ${key}:`, error);
                attributes.href = "#";
            }

            return attributes;
        };
        const bytesToSize = (bytes) => {
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes === null || bytes === undefined || isNaN(bytes) || bytes === 0) {
                return 'n/a';
            }
            bytes = parseFloat(bytes);
            if (bytes === 0) {
                 return 'n/a';
            }
            if (bytes < 0) {
                return 'n/a';
            }
            const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
            if (i === 0) {
                return Math.round(bytes) + ' ' + sizes[i];
            }
            return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
         };
        const updateFileSizes = (containerElement) => {
            if (!containerElement) return;
            const elements = containerElement.querySelectorAll('.js-fileSize');
            elements.forEach(element => {
                const bytesText = element.textContent;
                const bytesValue = parseFloat(bytesText);
                if (!isNaN(bytesValue)) {
                    element.textContent = '（' + bytesToSize(bytesValue) + '）';
                } else {
                    element.textContent = '';
                }
            });
         };
        const populateYearDropdown = (items) => {
            const years = [...new Set(items.map(item => item.cf_n_date ? new Date(item.cf_n_date).getFullYear() : null))]
                .filter(year => year !== null)
                .sort((a, b) => b - a);

            if (years.length > 0) {
                latestYearElement.textContent = years[0];
                earliestYearElement.textContent = years[years.length - 1];
                yearSelectElement.innerHTML = `<option value="all">${texts.latest}</option>`;
                years.forEach(year => {
                    const option = document.createElement('option');
                    option.value = year;
                    option.textContent = `${year}`;
                    yearSelectElement.appendChild(option);
                });
            } else {
                latestYearElement.textContent = '-';
                earliestYearElement.textContent = '-';
                yearSelectElement.innerHTML = `<option value="all">${texts.latest}</option>`;
            }
         };

        const renderNewsItemsForPage = (tabId, itemsToRender, listContainerElement) => {
            if (!listContainerElement) {
                console.error(`Error: News list container not found for tab ${tabId}.`);
                return;
            }
            listContainerElement.innerHTML = '';
            let newsHtml = '';

            if (itemsToRender.length === 0) {
                return;
            }

            itemsToRender.forEach(item => {
                const urlAttrs = generateUrlAttributes(item);
                const formattedDate = formatDate(item.cf_n_date);
                const showNew = isNew(item.cf_n_date);
                const categoryName = item.cf_n_category
                    ? (isEnglish ? item.cf_n_category.cf_nc_name_en : item.cf_n_category.cf_nc_name) || ''
                    : '';
                const title = (isEnglish ? item.cf_n_title_en : item.cf_n_title_jp) || '';
                const tagsHtml = item.cf_n_tags && Array.isArray(item.cf_n_tags) && item.cf_n_tags.length > 0
                    ? item.cf_n_tags
                          .map(tag => {
                              const tagName = (isEnglish ? tag.cf_nt_name_d_en : tag.cf_nt_name_d) || '';
                              return `<li class="js-news_tag"><span class="__tag">${tagName}</span></li>`;
                          })
                          .join('')
                    : '';

                let iconHtml = '';
                const hasAttachment = isEnglish
                    ? (item.cf_n_attachment_file_en && item.cf_n_attachment_file_en !== "")
                    : (item.cf_n_attachment_file_jp && item.cf_n_attachment_file_jp !== "");
                const isDirectFileLink = urlAttrs.href.includes('/news/news_file/file/');
                const isPdfInUrl = urlAttrs.href.toLowerCase().endsWith('.pdf');
                const fileSizeInBytes = isEnglish
                    ? item.cf_n_attachment_file_size_en ?? item.cf_n_url_file_size_en
                    : item.cf_n_attachment_file_size_jp ?? item.cf_n_url_file_size_jp;

                if (hasAttachment || isDirectFileLink || isPdfInUrl) {
                     const fileSizeValue = parseFloat(fileSizeInBytes);
                     const showFileSize = fileSizeInBytes !== null && !isNaN(fileSizeValue) && fileSizeValue >= 0;
                     iconHtml = `
                        <span class="js-news_icon">
                            (<span class="__pdf color-bg_red rt_icon_pdf">PDF</span>
                            ${showFileSize
                                ? `<span class="__byte rt_cf_n_attachment_file_size js-fileSize">${fileSizeValue}</span>`
                                : ''})
                        </span>`;
                }

                newsHtml += `
                    <a href="${urlAttrs.href}" target="${urlAttrs.target}" style="${urlAttrs.style}" class="news-article-block ${urlAttrs.class}">
                        <div class="news-article-block-txt">
                            <div class="news-article-block-txt-in">
                                ${showNew ? '<span class="__new js-news_new">NEW</span>' : ''}
                                <time class="__date js-news_date">${formattedDate}</time>
                                <span class="__label js-news_category">${categoryName}</span>
                            </div>
                            <h3 class="__title">
                                <span class="js-news_ttl">${title}</span>
                                ${iconHtml}
                            </h3>
                            ${tagsHtml ? `<ul class="news-article-block-tag">${tagsHtml}</ul>` : ''}
                        </div>
                    </a>
                `;
            });

            listContainerElement.innerHTML = newsHtml;
            updateFileSizes(listContainerElement);
        };

        const renderPagination = (tabId, paginationContainer, totalItems, currentPage) => {
            const paginateDiv = paginationContainer.querySelector('.mod-paginate');
            if (!paginateDiv) {
                console.error(`Error: .mod-paginate element not found within pagination container for tab ${tabId}.`);
                return;
            }

            const totalPages = Math.ceil(totalItems / itemsPerPage);
             // paginationContainer.style.display = totalPages > 1 ? '' : 'none';
            // if (totalPages <= 1) {
            //     paginateDiv.innerHTML = '';
            //     return;
            // }

            const prevLink = paginateDiv.querySelector('.mod-paginate-list-prev');
            const nextLink = paginateDiv.querySelector('.mod-paginate-list-next');

            if (!prevLink || !nextLink) {
                console.error(`Error: Pagination elements (prev, next) not found within .mod-paginate for tab ${tabId}.`);
                return;
            }

            let currentNode = prevLink.nextSibling;
            while (currentNode && currentNode !== nextLink) {
                let nodeToRemove = currentNode;
                currentNode = currentNode.nextSibling;
                paginateDiv.removeChild(nodeToRemove);
            }

            const maxVisiblePages = 5;
            let startPage, endPage;

            if (totalPages <= maxVisiblePages) {
                startPage = 1;
                endPage = totalPages;
            } else {
                const maxPagesBeforeCurrent = Math.floor(maxVisiblePages / 2);
                const maxPagesAfterCurrent = Math.ceil(maxVisiblePages / 2) - 1;
                if (currentPage <= maxPagesBeforeCurrent) {
                    startPage = 1;
                    endPage = maxVisiblePages;
                } else if (currentPage + maxPagesAfterCurrent >= totalPages) {
                    startPage = totalPages - maxVisiblePages + 1;
                    endPage = totalPages;
                } else {
                    startPage = currentPage - maxPagesBeforeCurrent;
                    endPage = currentPage + maxPagesAfterCurrent;
                }
            }

            for (let i = startPage; i <= endPage; i++) {
                let pageElement;
                if (i === currentPage) {
                    pageElement = document.createElement('span');
                    pageElement.classList.add('mod-paginate-list-in');
                    pageElement.textContent = i;
                } else {
                    pageElement = document.createElement('a');
                    pageElement.href = '#'; // href="#" を設定 (クリックイベントで処理するため)
                    pageElement.classList.add('mod-paginate-list-in');
                    pageElement.textContent = i;
                    pageElement.dataset.page = i; 
                }
                paginateDiv.insertBefore(pageElement, nextLink);
            }
            
            prevLink.style.pointerEvents = currentPage === 1 ? 'none' : '';
            prevLink.style.opacity = currentPage === 1 ? '0.5' : '';
            nextLink.style.pointerEvents = currentPage === totalPages ? 'none' : '';
            nextLink.style.opacity = currentPage === totalPages ? '0.5' : '';
        };

        // --- displayTabPage 関数の修正 ---
        // renderPagination 呼び出し時の引数を元に戻す
        const displayTabPage = (tabId, fullItemList, page) => {
            if (!tabPaginationState[tabId]) {
                tabPaginationState[tabId] = {};
            }
            tabPaginationState[tabId].currentPage = page;

            const totalItems = fullItemList.length;
            const startIndex = (page - 1) * itemsPerPage;
            const endIndex = startIndex + itemsPerPage;
            const itemsForCurrentPage = fullItemList.slice(startIndex, endIndex);

            const listContainerElement = document.querySelector(newsListContainerSelectors[tabId]);
            const paginationContainerElement = document.querySelector(paginationContainerSelectors[tabId]);

            if (!listContainerElement) {
                 console.error(`List container not found for tab ${tabId} in displayTabPage.`);
                 return;
            }

            renderNewsItemsForPage(tabId, itemsForCurrentPage, listContainerElement);

            if (totalItems === 0 && listContainerElement) {
                 listContainerElement.innerHTML = `<p>${texts.no_articles}</p>`;
            }

            // ページネーションコンテナが存在する場合のみレンダリング
            if (paginationContainerElement) {
                 if (totalItems > itemsPerPage) { // アイテム数が1ページ分より多い場合のみ表示
                     paginationContainerElement.style.display = ''; // 表示
                     renderPagination(tabId, paginationContainerElement, totalItems, page);
                 } else {
                     paginationContainerElement.style.display = 'none'; // 非表示
                 }
            }
        };

        const displayNews = () => {
            const selectedYear = yearSelectElement.value;

            /* // URL変更処理を無効化
            try {
                const currentPath = window.location.pathname;
                const basePath = isEnglish ? '/en/news/' : '/news/';
                let newPath;

                if (selectedYear === 'all') {
                    newPath = basePath;
                } else {
                    newPath = `${basePath}${selectedYear}/`;
                }

                if (newPath !== currentPath) {
                    history.pushState({ year: selectedYear }, '', newPath);
                }
            } catch (e) {
                console.error("History API pushState failed:", e);
            }
            */ // URL変更処理ここまで

            const yearFilteredItems = allNewsItems.filter(item => {
                if (selectedYear === 'all') return true;
                if (!item.cf_n_date) return false;
                try {
                    return new Date(item.cf_n_date).getFullYear() === parseInt(selectedYear, 10);
                } catch (e) {
                    return false;
                }
            });

            Object.keys(newsListContainerSelectors).forEach(tabId => {
                const allowedKeys = categoryKeyMappings[tabId];
                if (!allowedKeys) {
                    console.warn(`No category key mapping found for tab ${tabId}`);
                    tabFilteredData[tabId] = [];
                } else {
                    tabFilteredData[tabId] = yearFilteredItems.filter(item => {
                        return item.cf_n_category && typeof item.cf_n_category._key === 'number' && allowedKeys.includes(item.cf_n_category._key);
                    });
                }

                displayTabPage(tabId, tabFilteredData[tabId], 1);
            });
        };

        fetch(jsonPath)
            .then(response => {
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                return response.json();
            })
            .then(data => {
                if (!data || !Array.isArray(data.rt_bn_news_info_json)) {
                    throw new Error('Invalid JSON data structure');
                }
                allNewsItems = data.rt_bn_news_info_json;

                allNewsItems.sort((a, b) => {
                    const dateA = a.cf_n_date ? new Date(a.cf_n_date) : null;
                    const dateB = b.cf_n_date ? new Date(b.cf_n_date) : null; // Corrected: b.cf_n_date
                    if (!dateA && !dateB) return 0;
                    if (!dateA) return 1; // Place items without date at the end
                    if (!dateB) return -1; // Place items without date at the end
                    return dateB - dateA; // Sort by date descending (newest first)
                });

                populateYearDropdown(allNewsItems);

                displayNews(); 

                yearSelectElement.addEventListener('change', displayNews);

                // --- ここからイベントデリゲーションによるリスナー設定 ---
                Object.keys(paginationContainerSelectors).forEach(tabId => {
                    const paginationContainer = document.querySelector(paginationContainerSelectors[tabId]);
                    if (paginationContainer) {
                        paginationContainer.addEventListener('click', (e) => {
                            const target = e.target.closest('a'); // クリックされた要素またはその祖先のaタグを取得
                            if (!target) return; // aタグでなければ何もしない

                            let newPage = -1;
                            // 現在のページを tabPaginationState から取得 (なければ1)
                            const currentPage = tabPaginationState[tabId]?.currentPage || 1;
                            // 現在のタブのアイテム数を tabFilteredData から取得
                            const totalItems = tabFilteredData[tabId] ? tabFilteredData[tabId].length : 0;
                            // 総ページ数を計算
                            const totalPages = Math.ceil(totalItems / itemsPerPage);

                            // クリックされた要素がページネーションリンクか判定
                            if (target.matches('.mod-paginate-list-prev')) {
                                e.preventDefault();
                                if (currentPage > 1) {
                                    newPage = currentPage - 1;
                                }
                            } else if (target.matches('.mod-paginate-list-next')) {
                                e.preventDefault();
                                // totalPages を使用して判定
                                if (currentPage < totalPages) {
                                    newPage = currentPage + 1;
                                }
                            } else if (target.matches('a.mod-paginate-list-in') && target.dataset.page) {
                                e.preventDefault();
                                const pageNum = parseInt(target.dataset.page, 10);
                                if (!isNaN(pageNum) && pageNum !== currentPage) {
                                    newPage = pageNum;
                                }
                            }

                            // 新しいページ番号が有効ならページ切り替えとスクロールを実行
                            if (newPage !== -1) {
                                // スクロール処理 (変更なし)
                                const newsSection = document.getElementById('news');
                                if (newsSection) {
                                    setTimeout(() => {
                                        newsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                    }, 100);
                                } else {
                                     setTimeout(() => { window.scrollTo(0, 0); }, 100);
                                }

                                // ページ切り替え (変更なし)
                                if (tabFilteredData[tabId]) {
                                    displayTabPage(tabId, tabFilteredData[tabId], newPage);
                                } else {
                                    console.error(`tabFilteredData not available for tab ${tabId} on pagination click.`);
                                }
                            }
                        });
                    }
                });
                // --- イベントデリゲーション リスナー設定ここまで ---

            })
            .catch(error => {
                console.error('Error fetching or processing news data:', error);
                Object.values(newsListContainerSelectors).forEach(selector => {
                    const container = document.querySelector(selector);
                    if (container) {
                         container.innerHTML = `<p>${texts.error_loading}</p>`;
                    }
                });
                 Object.values(paginationContainerSelectors).forEach(selector => {
                    const container = document.querySelector(selector);
                    if (container) {
                        container.style.display = 'none';
                    }
                });
            });
    }; // initializeNewsTabs 終了

    // --- window.onload と hashchange で handleHashChange を実行 ---
    const handleHashChange = () => {
        const hash = window.location.hash;
        let targetTabId = null;
        let shouldScroll = false;

        switch (hash) {
            case '#menu02':
                targetTabId = 'menu02';
                shouldScroll = true;
                break;
            case '#menu03': // IR情報タブのハッシュ例 (必要に応じて調整)
                targetTabId = 'menu03';
                shouldScroll = true;
                break;
            case '#menu01': // すべてタブのハッシュ例 (必要に応じて調整)
                 targetTabId = 'menu01';
                 shouldScroll = true; // スクロールが必要な場合
                 break;
        }

        if (targetTabId) {
            const targetTabRadio = document.getElementById(targetTabId);
            if (targetTabRadio) {
                targetTabRadio.checked = true;
                // 注意: タブ切り替えに伴うデータ再表示が必要な場合、
                // displayTabPage をここで呼び出す必要があるかもしれないが、
                // 既存のタブクリックイベントとの二重実行にならないよう注意が必要。
            }
        }

        if (shouldScroll) {
            const newsSection = document.getElementById('news');
            if (newsSection) {
                // ハッシュ変更時のスクロール
                setTimeout(() => {
                    // behavior を 'smooth' に変更
                    newsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 500); // 遅延は維持
            }
        }
    };

    // ページ読み込み完了時 (画像なども含む) にハッシュを処理
    window.addEventListener('load', handleHashChange);
    // ハッシュが変更されたときも処理
    window.addEventListener('hashchange', handleHashChange);

    newsCurrent();
    newsTopicsSlide();
    initializeNewsTabs();

})(window.JDI);